<template>
  <div class="text-item-content">
    <div class="text-title">{{title}}</div>
    <div class="text-content">{{datamodel.value}}</div>
  </div>
</template>

<script>

export default {
  uuid: "00000000-0000-0000-0000-000000000004",
  components: {},
  props: [
    'datamodel',
  ],
  data() {
    return {
      
    }
  },
  computed: {
    title() {
      if(this.$i18n.locale == 'zh-CN'){
        return this.datamodel.zhlabel.replace(/\//g, ' / ')  
      }
      return this.datamodel.enlabel.replace(/\//g, ' / ')
    }
  },
  methods: {
    
  },
  created() {},
  mounted() {

  }
}
</script>
<style lang="scss">


</style>
